module.exports = __webpack_public_path__ + "img/viewMark.467ed9d4.svg";